import { render, staticRenderFns } from "./Reasons.vue?vue&type=template&id=7275702e&"
import script from "./Reasons.vue?vue&type=script&lang=js&"
export * from "./Reasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports